/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ReactSlider from 'react-slider';
import { FormattedNumber } from 'react-intl';
import Loading from 'app/components/common/Loading.jsx';
import * as _ from 'underscore';
import classnames from 'classnames';
import AddTweetModal from 'app/components/Subscription/AddTweetModal.jsx';
import ConfirmationModal from 'app/components/Subscription/ConfirmationModal.jsx';

class LegacyPricing extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            add_on_posts_1: 0
        };

        this.getLimit = this.getLimit.bind(this);
        this.setAddOns = this.setAddOns.bind(this);
        this.addPosts = this.addPosts.bind(this);
        this.subscriptionUpdate = this.subscriptionUpdate.bind(this);

    }

    componentDidMount() {

        this.setAddOns();

        if (dataLayer) {
            dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {'step': 1, 'option': 'Upgrade Legacy'}
                    }
                }
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if ((_.isEmpty(prevProps.plans.current) && !_.isEmpty(this.props.plans.current)) &&
            this.props.plans.current.addOns &&
            this.props.plans.current.addOns != prevProps.plans.current.addOns ||
            !_.isEmpty(this.props.errors)) {
            this.setAddOns(this.props);
        }

    }

    setAddOns() {
        let addOnPosting = 0;

        if (this.props.plans.current.addOns && this.props.plans.current.addOns.add_on_posts_1) {
            addOnPosting = parseInt(this.props.plans.current.addOns.add_on_posts_1.qty, 10);
        }
        if (addOnPosting != this.state.add_on_posts_1) {
            this.setState({
                add_on_posts_1: addOnPosting
            });
        }

    }

    getLimit(limit) {

        return (limit === -1 || limit === "-1") ? "Unlimited" : limit;

    }

    addPosts(nextQuantity) {
        let constants = this.props.app.config.constants,
            subscriptionInfo = {
                subscription: this.props.plans.current,
                addOns: {
                    add_on_posts_1: nextQuantity
                }
            },
            addOns = [
                {
                    addOn: constants.SUBSCRIPTION_ADDON_POSTS_1,
                    quantity: nextQuantity
                }
            ],
            newLimits = {},
            confirmation = null,
            currentQuantity = 0;
                
        if (_.isObject(this.props.plans.current.addOns.add_on_posts_1)) {
            currentQuantity = this.props.plans.current.addOns.add_on_posts_1.qty;
        };

        this.setState({
            add_on_posts_1: nextQuantity
        });

        newLimits = this.props.calculateAddOns(addOns);

        confirmation = (
            <ConfirmationModal
                {...this.props}
                confirmationType="addposts"
                confirmationAction={this.subscriptionUpdate}
                subscription={subscriptionInfo}
                newLimits={newLimits}
                addOnType="posts"
                planTerm={this.props.plans.current.planTerm} />
        );


        if (mixpanel) {
            let action = "Add Posts Upgrade Started";
            if (this.props.plans.current.addOns.add_on_posts_1) {
                if (this.state.add_on_posts_1 < currentQuantity) {
                    action = "Add Posts Downgrade Started";
                }
            }
            mixpanel.track(action);
        }

        if (gtag) {
            let promoData = this.props.getPersistedData('gaPromo');

            gtag('event', 'begin_checkout', {
                currency: 'USD',
                value: 1.0,
                items: [{
                    item_id: 'dlvrit_1',
                    item_name: 'dlvr.it premium plan',
                    item_variant: (this.state.add_on_posts_1 > currentQuantity) ? 'Purchase Add-On Posts' : 'Remove Add-On Posts',
                    price: 1.0,
                    quantity: 1,
                    promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                    promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                }],

            });

            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: (this.state.add_on_posts_1 > currentQuantity) ? 'Purchase Add-On Posts' : 'Remove Add-On Posts',
                    event_data: {
                        quantity: this.state.add_on_posts_1
                    }
                });
            }

        }

        this.props.closeOtherModals(confirmation);
    }

    subscriptionUpdate(which) {

        if (which === "posts") {
            this.props.onAddOnUpdate({
                add_on_posts_1: this.state.add_on_posts_1
            });
        }

    }

    render() {
        let constants = this.props.app.config.constants,
            annualPitch = null,
            sliderPos = 0,
            termLabel = '',
            termShortLabel = '',
            headerClass = 'current-sub-header',
            planLabel = '',
            planPriceLabel = '',
            currentAddOns = (this.props.user.plan.addOns && this.props.user.plan.addOns.add_on_social) ? this.props.user.plan.addOns.add_on_social.qty : 0,
            currentPostAddOns = (this.props.user.plan.addOns && this.props.user.plan.addOns.add_on_posts_1) ? this.props.user.plan.addOns.add_on_posts_1.qty : 0,
            currentLimits = this.props.calculateAddOns([{
                addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
                quantity: currentAddOns
            },
            {
                addOn: constants.SUBSCRIPTION_ADDON_POSTS_1,
                quantity: currentPostAddOns
            }]),
            errorBlock = null;

        if (_.isEmpty(this.props.user.plan) || _.isEmpty(this.props.planDetails) || this.props.app.loading.SUB_FETCH_DETAIL) {
            return (
                <Loading />
            );
        }

        if (currentAddOns) {
            planLabel = 'dlvr.it ' + this.props.user.plan.planName + ' + ' + currentAddOns + ' add-ons';
        } else {
            planLabel = 'dlvr.it ' + this.props.user.plan.planName;
        }

        if (this.props.user.plan.planTerm == constants.SUBSCRIPTION_TERM_MONTHLY) {
            termLabel = "Month";
            annualPitch = (<span>Save up to 28% when you switch to <a href="#" onClick={(e) => {
                this.props.changeTerm(e, this.props.setRequestParams);
            }} data-term={constants.SUBSCRIPTION_TERM_ANNUAL}>Annual Billing</a></span>);
            termShortLabel = 'mo';
        } else {
            termLabel = "Year";
            annualPitch = (<span>Switch to <a href="#" onClick={(e) => {
                this.props.changeTerm(e, this.props.setRequestParams);
            }} data-term={constants.SUBSCRIPTION_TERM_MONTHLY}>Monthly Billing</a></span>)
            termShortLabel = 'yr';
        }

        planPriceLabel = (<span><FormattedNumber value={currentLimits.price} style="currency" currency="USD"/> / {termLabel}</span>);

        if (this.props.errors !== null) {
            if (this.props.errors.update.errors.subscription.limits) {
                errorBlock = (
                    <div className="subscription-error">
                        {"Your selected plan won't support your current usage. Please turn off or remove feeds and socials to fit in the new plan."}
                    </div>
                );
            } else {
                errorBlock = (
                    <div className="subscription-error">
                        We {"couldn't"} complete your transaction. Please <a href="/account/billing">update your billing information.</a>
                    </div>
                );
            }

        }

        let xtraXeets = null,
            xPostsButton = null;
        if (this.props.user.detail.pubLevel === constants.PUB_LEVEL_3) {
            xPostsButton = (
                <div className="x-posts-block">
                    <div className="x-posts-button btn-primary reverse-fixed" role="button" onClick={(e) => {
                        if (this.props.recordEvent) {
                            this.props.recordEvent({
                                pub_id: this.props.user.detail.id,
                                event_name: 'Click Add Tweets Button',
                                event_data: {
                                    source: 'legacy'
                                }
                            });
                        }
                        let tweetModal = (
                            <AddTweetModal
                                {...this.props}
                                currentQuantity={this.state.add_on_posts_1}
                                addPosts={this.addPosts}
                                dismissModal={(e) => {
                                    this.props.closeAllModals();
                                }}
                                termLabel={termShortLabel}/>
                        );
                        this.props.addModal(tweetModal);
                    }} aria-label="Purchase more X Posts">
                        Need more X (Twitter) Posts?
                    </div>
                </div>
            );


            if (currentLimits.addOnPosts > 0) {
                xtraXeets = (
                    <div className="resource-usage xeets">
                        {currentLimits.addOnPosts} X Posts - <span className="in-use-label">{this.props.user.perms.resources.extraTweetsRemaining} available</span>
                    </div>
                );
            }
        } else if (this.props.user.detail.pubLevel === constants.PUB_LEVEL_4) {
            xPostsButton = (
                <div className="x-posts-block">
                    <div className="x-posts-enterprise">
                        Need more X (Twitter) posts? Contact support and we can get that set up for you.
                    </div>
                </div>
            );
        }

        return (
            <div className="current-subscription">
                <div className={headerClass}>
                    <div className="plan-name">
                        Your Plan: {planLabel}
                    </div>
                    <div className="plan-price">
                        {planPriceLabel}
                    </div>
                </div>
                {errorBlock}
                <div className="plan-detail-block">
                    <div className="resource-usage outputs">
                        {this.getLimit(currentLimits.outputs)} Social Profiles - <span className="in-use-label">{currentLimits.outputsInUse} in use</span>
                    </div>
                    <div className="resource-usage inputs">
                        {this.getLimit(currentLimits.inputs)} Feeds and Sites - <span className="in-use-label">{currentLimits.inputsInUse} in use</span>
                    </div>
                    {xtraXeets}
                </div>
                {xPostsButton}
            </div>
        );
    }

};

LegacyPricing.displayName = "LegacyPricing";

LegacyPricing.propTypes = {
    currentSubscription: PropTypes.object,
    planDetails: PropTypes.object,
    onAddOnUpdate: PropTypes.func,
    subscriptionUpdate: PropTypes.func,
    errors: PropTypes.object
};

LegacyPricing.defaultProps = {
    currentSubscription: {},
    planDetails: {},
    onAddOnUpdate: null,
    subscriptionUpdate: null,
    errors: null
};

export default LegacyPricing;
